// @flow
export const cycle = <T>(data: T[], count: number) =>
  [...Array(count).keys()].reduce((newArray, _, index) => {
    newArray.push(data[index % data.length])
    return newArray
  }, [])
